/**
 * variable used for the presale smart contract
 * of different network
 */

import { ChainNamespace } from '@reown/appkit/networks';
import { Address, encodeFunctionData, formatUnits, parseUnits } from 'viem';
import { environment } from '../../../environments/environment';
import { IAllDataItems, IBalnceDataEVM, IBalnceDataSOL, ITokenData } from '../interfaces/wallet.interface';
import { readContracts } from '@wagmi/core';
import { getParam } from './app-enums';

export const staking = require('../../../assets/contracts/staking.json');
export const token = require('../../../assets/contracts/token.json');

export const presaleEth = require('../../../assets/contracts/presaleETH.json');
export const presaleBsc = require('../../../assets/contracts/presaleBSC.json');
export const presalePoly = require('../../../assets/contracts/presalePOLY.json');
export const presaleArb = require('../../../assets/contracts/presaleARB.json');



export const eth_usdt_token = require('../../../assets/contracts/eth_usdt_token.json');
export const bsc_usdt_token = require('../../../assets/contracts/bsc_usdt_token.json');
export const poly_usdt_token = require('../../../assets/contracts/poly_usdt_token.json');
export const arb_usdt_token = require('../../../assets/contracts/arb_usdt_token.json');
export const arb_arb_token = require('../../../assets/contracts/arb_arb_token.json');


export const multicallBsc = require('../../../assets/contracts/multicallBsc.json');
export const multicallEth = require('../../../assets/contracts/multicallEth.json');
export const eth_usdc_token = require('../../../assets/contracts/eth_usdc_token.json');
export const bsc_usdc_token = require('../../../assets/contracts/bsc_usdc_token.json');
export const poly_usdc_token = require('../../../assets/contracts/poly_usdc_token.json');
export const arb_usdc_token = require('../../../assets/contracts/arb_usdc_token.json');
export const presaleSol = require('../../../assets/contracts/presaleSOL.json');

export const MULTI_ROUTER = require('../../../assets/contracts/multiRouter.json');
export const ERC_20_TOKEN = require('../../../assets/contracts/ERC-20-Token.json');

/**
 * here the presale ABI and Address are set
 * for read, write and prepair contract
 */
export const stakeContract = {
  address: environment.stakingAddress as Address,
  abi: staking.abi,
} as const;

export const presaleContractEth = {
  address: environment.eth.presaleAddress as Address,
  abi: presaleEth.abi,
} as const;

export const presaleContractBsc = {
  address: environment.bsc.presaleAddress as Address,
  abi: presaleBsc.abi,
} as const;

export const ethUsdtContract = {
  address: environment.eth.usdTAddress as Address,
  abi: eth_usdt_token.abi,
} as const;

export const bscUsdtContract = {
  address: environment.bsc.usdTAddress as Address,
  abi: bsc_usdt_token.abi,
} as const;

export const multicallEthContract = {
  address: environment.eth.multicall as Address,
  abi: multicallEth.abi,
} as const;

export const multicallBscContract = {
  address: environment.bsc.multicall as Address,
  abi: multicallBsc.abi,
} as const;

export const ethUsdcContract = {
  address: environment.eth.usdcAddress as any,
  abi: eth_usdc_token.abi,
} as const;

export const bscUsdcContract = {
  address: environment.bsc.usdcAddress as any,
  abi: bsc_usdc_token.abi,
} as const;


export const presaleContractPoly = {
  address: environment.polygon.presaleAddress as Address,
  abi: presalePoly.abi,
} as const;

export const polyUsdtContract = {
  address: environment.polygon.usdTAddress as Address,
  abi: poly_usdt_token.abi,
} as const;

export const multicallContractPoly = {
  address: environment.polygon.multicall as Address,
  abi: multicallEth.abi,
} as const;

export const polyUsdcContract = {
  address: environment.polygon.usdcAddress as any,
  abi: poly_usdc_token.abi,
} as const;

export const presaleContractArb = {
  address: environment.arbitrum.presaleAddress as Address,
  abi: presaleArb.abi,
} as const;

export const multicallContractArb = {
  address: environment.arbitrum.multicall as Address,
  abi: multicallEth.abi,
} as const;

export const arbUsdtContract = {
  address: environment.arbitrum.usdTAddress as Address,
  abi: arb_usdt_token.abi,
} as const;

export const arbUsdcContract = {
  address: environment.arbitrum.usdcAddress as any,
  abi: arb_usdc_token.abi,
} as const;

export const arbARBContract = {
  address: environment.arbitrum.arbAddress as any,
  abi: arb_arb_token.abi,
} as const;


// Reusable ERC-20 ABI standard for USDT, USDC, and ARB balances
const erc20BalanceOfAbi = [
  {
    name: 'balanceOf',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ name: 'account', type: 'address' }],
    outputs: [{ name: 'balance', type: 'uint256' }],
  }
] as const;

export const arbTokenContract = {
  address: environment.arbitrum.arbAddress as Address,
  abi: erc20BalanceOfAbi,
} as const;

export const multiRouterContract = {
  address: '',
  abi: MULTI_ROUTER.abi,
} as const;


export function getChainData(chainId: number) {
  switch (chainId) {
    case environment.eth.chainIdInt:
      return environment.eth;

    case environment.bsc.chainIdInt:
      return environment.bsc;

    case environment.polygon.chainIdInt:
      return environment.polygon;

    case environment.arbitrum.chainIdInt:
      return environment.arbitrum;

    case environment.sol.chainIdInt:
      return environment.sol;

    default:
      return environment.eth;
  }
}

export function getPresaleContract(chainId: number) {
  switch (chainId) {
    case environment.eth.chainIdInt:
      return presaleContractEth;

    case environment.bsc.chainIdInt:
      return presaleContractBsc;

    case environment.polygon.chainIdInt:
      return presaleContractPoly;

    case environment.arbitrum.chainIdInt:
      return presaleContractArb;

    default:
      return presaleContractEth;
  }
}

export function getUSDTContract(chainId: number) {
  switch (chainId) {
    case environment.eth.chainIdInt:
      return ethUsdtContract;

    case environment.bsc.chainIdInt:
      return bscUsdtContract;

    case environment.polygon.chainIdInt:
      return polyUsdtContract;

    case environment.arbitrum.chainIdInt:
      return arbUsdtContract;

    default:
      return ethUsdtContract;
  }
}

export function getUSDCContract(chainId: number) {
  switch (chainId) {
    case environment.eth.chainIdInt:
      return ethUsdcContract;

    case environment.bsc.chainIdInt:
      return bscUsdcContract;

    case environment.polygon.chainIdInt:
      return polyUsdcContract;

    case environment.arbitrum.chainIdInt:
      return arbUsdcContract;

    default:
      return ethUsdcContract;
  }
}

/**
 * method to adjust unsold token
 * @param arr the array that need to be adjusted
 * @param skipIndex index no that need to be ignored or skipped
 * @returns a fresh set of array after all adjustment
 */

export function skipIndexUpdate(arr: Array<any>, skipIndex: Array<any>): Array<any> {
  let newArr: number[] = [];
  for (let i = 0; i < arr.length; i++) {
    if (!skipIndex.includes(i)) {
      newArr.push(Number(arr[i]));
    }
  }
  return newArr;
}


/**  Referral **/
export const checkIsValidReferral = async (referralAddress: string, chainId: number, walletAddress: string, config: any) => {
  return true;
  try {
    if (typeof window == "undefined") return;
    const smartContracts = {
      contracts: [
        {
          ...getPresaleContract(chainId),
          functionName: 'checkReferralStatus',
          chainId: chainId,
          args: [referralAddress, walletAddress]
        }
      ]
    }

    const result = await readContracts(config, smartContracts);
    console.log("checkIsValidReferral", result)
    const isRefferalAvailable = result[0].result || false
    return (!referralAddress || referralAddress === walletAddress) ? false : isRefferalAvailable;

  } catch (error) {
    return false;
  }
}

/**
 * generate signature for wert transaction
 * @param amount Amount to spend
 * @returns signature data
 */
export async function getABI(amount: number, isStake: boolean = false, walletAddress: string, chainId: number, wagmiConfig: any): Promise<string> {
  // const referralAddress = getParam('refAddressEvm') || "0x0000000000000000000000000000000000000000";
  // const isValidReferral = await checkIsValidReferral(referralAddress, chainId, walletAddress, wagmiConfig);
  // const referral = isValidReferral ? referralAddress : "0x0000000000000000000000000000000000000000";
  const refferal = "0x0000000000000000000000000000000000000000";

  const data = encodeFunctionData({
    abi: presaleEth.abi,
    functionName: 'buyWithUSDCWERT',
    args: [walletAddress, amount, isStake, refferal],
  });
  return data;
}


export const getNativeAmount = async (amount: number, symbol: string, balanceData: IAllDataItems) => {
  let singleAmount = 0;
  switch (symbol) {
    case 'ETH':
      singleAmount = balanceData.buyHelperETH ?? 0;
      break;

    case 'BNB':
      singleAmount = balanceData.buyHelperBSC ?? 0;
      break;

    case 'POL':
      singleAmount = balanceData.buyHelperPoly ?? 0;
      break;

    case 'ARB':
      singleAmount = balanceData.buyHelperArb ?? 0;
      break;

    case 'SOL':
      singleAmount = balanceData.oneSol ?? 0;
      break;

    default:
      singleAmount = balanceData.buyHelperETH ?? 0;
  }
  return Math.floor(+(amount / +singleAmount));
};

export const getHelperAmount = (chainId: number, balanceData: IBalnceDataEVM): number => {
  // If balanceData isn't initialized yet, return a safe minimal placeholder
  if (!balanceData) return 0.0001;

  switch (chainId) {
    case environment.eth.chainIdInt:
      return balanceData.buyHelperETH ?? 0.0001;

    case environment.bsc.chainIdInt:
      return balanceData.buyHelperBSC ?? 0.0001;

    case environment.polygon.chainIdInt:
      return balanceData.buyHelperPoly ?? 0.0001;

    case environment.arbitrum.chainIdInt:
      return balanceData.buyHelperArb ?? 0.0001;

    default:
      return balanceData.buyHelperETH ?? 0.0001;
  }
};

/**
 * calculating the available no of token in exchange of inserted Usdt amount
 */

export async function getExternalTokenAmount(noToken: number, activeToken: ITokenData, balanceData: IAllDataItems) {
  let singleAmount = Number((activeToken.tokenValUsd ?? 0) / ((balanceData.usdtBuyHelperETH ?? 0) / Math.pow(10, 6)));
  // switch (activeToken.symbol) {
  //   case 'MT':
  //     singleAmount = Number((activeToken.tokenValUsd ?? 0) / ((balanceData.usdtBuyHelperETH ?? 0) / Math.pow(10, 6)));
  //     break;


  //   default:
  //      singleAmount = Number((activeToken.tokenValUsd ?? 0) / ((balanceData.usdtBuyHelperETH ?? 0) / Math.pow(10, 6)));
  // }
  console.log('getExternalTokenAmount called', { singleAmount, noToken, activeToken, balanceData })
  return noToken * singleAmount;
}
/**
 * calculating the available no of token in exchange of inserted Usdt amount
 */

export async function getUSDTAmount(amount: number, chainId: number, balanceData: IAllDataItems) {
  let singleAmount = 0;
  switch (getChainData(chainId).chainIdInt) {
    case environment.eth.chainIdInt:
      singleAmount = (balanceData.usdtBuyHelperETH ?? 0) / Math.pow(10, 6);
      break;

    case environment.bsc.chainIdInt:
      singleAmount = (balanceData.usdtBuyHelperBSC ?? 0) / Math.pow(10, 18);
      break;

    case environment.polygon.chainIdInt:
      singleAmount = (balanceData.usdtBuyHelperPoly ?? 0) / Math.pow(10, 6);
      break;

    case environment.arbitrum.chainIdInt:
      singleAmount = (balanceData.usdtBuyHelperArb ?? 0) / Math.pow(10, 6);
      break;

    case environment.sol.chainIdInt:
      singleAmount = (balanceData?.solUsdt ?? 0) / Math.pow(10, 6);
      break;

    default:
      singleAmount = (balanceData.usdtBuyHelperETH ?? 0) / Math.pow(10, 6);
  }
  return Math.floor(+(amount / +singleAmount));
}

/**
 * reverse calculation required amount (eth/bnb/usdt)
 * in exchange of inserted token
 * @param amount : no of token
 * @param mode : exchange mode
 * @returns : required amount
 */

export async function getDynamicAmount(amount: number, mode: string, chainId: number, balanceData: IBalnceDataEVM | IBalnceDataSOL) {
  let singleAmount = 0;
  const evm = balanceData as Partial<IBalnceDataEVM>;
  const sol = balanceData as Partial<IBalnceDataSOL>;
  switch (getChainData(chainId).chainIdInt) {
    case environment.eth.chainIdInt:
      if (mode === 'getNativeAmount') {
        singleAmount = evm.buyHelperETH ?? 0;
      } else {
        singleAmount = (evm.usdtBuyHelperETH ?? 0) / Math.pow(10, 6);
      }
      break;

    case environment.bsc.chainIdInt:
      if (mode === 'getNativeAmount') {
        singleAmount = evm.buyHelperBSC ?? 0;
      } else {
        singleAmount = (evm.usdtBuyHelperBSC ?? 0) / Math.pow(10, 18);
      }
      break;

    case environment.polygon.chainIdInt:
      if (mode === 'getNativeAmount') {
        singleAmount = evm.buyHelperPoly ?? 0;
      } else {
        singleAmount = (evm.usdtBuyHelperPoly ?? 0) / Math.pow(10, 6);
      }
      break;

    case environment.arbitrum.chainIdInt:
      if (mode === 'getNativeAmount') {
        singleAmount = evm.buyHelperArb ?? 0;
      } else {
        singleAmount = (evm.usdtBuyHelperArb ?? 0) / Math.pow(10, 6);
      }
      break;

    case environment.sol.chainIdInt:
      if (mode === 'getNativeAmount') {
        singleAmount = sol.oneSol ?? 0;
      } else {
        console.log('solana usdt', sol.solUsdt)
        singleAmount = (sol.solUsdt ?? 0) / Math.pow(10, 6);
      }
      break;

    default:
      if (mode === 'getNativeAmount') {
        singleAmount = evm.buyHelperETH ?? 0;
      } else {
        singleAmount = (evm.usdtBuyHelperETH ?? 0) / Math.pow(10, 6);
      }
      break;
  }
  return +(amount * singleAmount);
}

/**
 * reverse calculation required amount (eth/bnb/usdt)
 * in exchange of inserted token
 * @param amount : no of token
 * @param mode : exchange mode
 * @returns : required amount
 */

export async function getExternalDynamicAmount(amount: number, activeToken: ITokenData, balanceData: IAllDataItems) {
  let singleAmount = 0
  switch (activeToken.category) {
    case 'ETH':
      singleAmount = (balanceData.usdtBuyHelperETH ?? 0) / Math.pow(10, 6) / (activeToken.tokenValUsd ?? 1);
      break;

    case 'BSC':
      singleAmount = (balanceData.usdtBuyHelperBSC ?? 0) / Math.pow(10, 18) / (activeToken.tokenValUsd ?? 1);
      break;


    default:
      singleAmount = (balanceData.usdtBuyHelperETH ?? 0) / Math.pow(10, 6);
  }
  return +(amount * (singleAmount ?? 0));
}
/**
 * reverse calculation required amount (eth/bnb/usdt)
 * in exchange of inserted token
 * @param amount : no of token
 * @param mode : exchange mode
 * @returns : required amount
 */

export async function getDynamicAmountv2(amount: number, symbol: string, category: string, tokensData: ITokenData[], chainId: number, balanceData: IAllDataItems) {
  let token = tokensData.filter((x: ITokenData) => x.symbol === symbol)[0];
  let singleAmount = chainId == environment.eth.chainIdInt ? balanceData.buyHelperETH : balanceData.buyHelperBSC;
  switch (symbol) {
    case 'ETH':
      singleAmount = balanceData.buyHelperETH;
      break;

    case 'BNB':
      singleAmount = balanceData.buyHelperBSC;
      break;

    case 'POL':
      singleAmount = balanceData.buyHelperPoly;
      break;

    case 'ARB':
      singleAmount = balanceData.buyHelperArb;
      break;

    case 'SOL':
      singleAmount = balanceData.oneSol ?? 0;
      break;

    case 'USDT':
      if (category === 'ETH') {
        singleAmount = (balanceData.usdtBuyHelperETH ?? 0) / Math.pow(10, 6);
      } else if (category === 'BSC') {
        singleAmount = (balanceData.usdtBuyHelperBSC ?? 0) / Math.pow(10, 18);
      } else if (category === 'POL') {
        singleAmount = (balanceData.usdtBuyHelperPoly ?? 0) / Math.pow(10, 6);
      } else {
        singleAmount = (balanceData.usdtBuyHelperArb ?? 0) / Math.pow(10, 6);
      }
      break;

    default:
      singleAmount = balanceData.usdtBuyHelperETH;
  }
  return +(amount * (singleAmount ?? 0));
}

export function getGasFees(chainId: number) {
  let gas = 0;
  switch (chainId) {
    case environment.eth.chainIdInt:
      gas = environment.eth.gasFees
      break;

    case environment.bsc.chainIdInt:
      gas = environment.bsc.gasFees
      break;

    case environment.polygon.chainIdInt:
      gas = environment.polygon.gasFees
      break;

    case environment.arbitrum.chainIdInt:
      gas = environment.arbitrum.gasFees
      break;

    case environment.sol.chainIdInt:
      gas = environment.sol.gasFees;
      break;

    default:
      gas = environment.eth.gasFees
      break;
  }

  return gas;

}

export function isSolanaActivated(chainNameSpace: ChainNamespace[]) {
  return chainNameSpace?.filter((item) => item === 'solana').length > 0;
}

export function isEmptyObject(obj: object): boolean {
  return Object.keys(obj).length === 0;
}